import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  AuditAlertResponse,
  AuditAlertsRequestParams
} from "../../auditLog.types";
import { requestGetAuditAlerts } from "./getAuditAlerts.request";

const useGetAuditAlerts = (
  requestParams: AuditAlertsRequestParams,
  options?: QueryOptions<
    GetListResponse<AuditAlertResponse>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["audit-alerts", "admin", "all", requestParams],
    queryFn: async () => await requestGetAuditAlerts(requestParams),
    onError: toastServerError,
    ...options
  });

  return { auditAlerts: data?.data, meta: data?.meta, ...rest };
};

export default useGetAuditAlerts;
